import { analyze, get, list, search } from "./endpoints";

export {
  AiCallDimension,
  AiCallFilter,
  AiCallOrder,
  AiCallTotals,
  AnalyzeAiCallsRequest,
  AnalyzeAiCallsResponse,
  SearchAiCallsRequest,
  SearchAiCallsResponse,
} from "./analytics";
export {
  AiCall,
  AiCallDetail,
  AiCallId,
  AiCallParams,
  ListAiCallsQuery,
  ListAiCallsResponse,
} from "./schemas";
export { service } from "./service";

export const contract = {
  list,
  get,
  analyze,
  search,
} as const;
